import { Platform, useWindowDimensions } from 'react-native';
import { isMobileWebLayout } from '../widget/widgetPosition';

/** iOS Safari zooms into a focused field whose text is smaller than this. */
const IOS_NO_ZOOM_FONT_SIZE = 16;

/**
 * CORE-311 (QA 16.10) — font size for a text field that must not zoom the page.
 *
 * iOS Safari zooms into any focused field under 16px and stays zoomed after the
 * keyboard closes — across navigation too, until the user pinches back. On a
 * phone-width web viewport the field gets at least 16px; elsewhere (desktop,
 * native) it keeps its own size.
 */
export function useNoZoomFontSize(size: number): number {
  const { width } = useWindowDimensions();
  return isMobileWebLayout(Platform.OS === 'web', width) ? Math.max(size, IOS_NO_ZOOM_FONT_SIZE) : size;
}
